<script lang="ts">
  import { OctagonAlertIcon } from "lucide-svelte";

  export let error: string;
  export let help: string | null = null;
</script>

<p class="text-sm mt-3 flex items-center">
  <OctagonAlertIcon class="w-4 h-4 mr-1 text-red-500" />
  <span class="text-red-500 mr-1">{error}</span>
  {#if help}
    <span class="text-white/60">{help}</span>
  {/if}
</p>
